import { useEffect, useState } from "react"

export const RoiVertex = ({ pointX, pointY, handlePointChange }) => {
    const [position, setPosition] = useState({ x: pointX, y: pointY });
    const handleMouseDown = (e) => {
        e.preventDefault()
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }

    const handleMouseMove = (event) => {
        setPosition({x: event.offsetX, y: event.offsetY})
        handlePointChange(event.offsetX, event.offsetY)
    };

    const handleMouseUp = (event) => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        handlePointChange(event.offsetX, event.offsetY)
    };

    useEffect(() => {
        setPosition({
            x: pointX,
            y: pointY
        })
    }, [pointX, pointY])

    return pointX && pointY && <rect
        className="roi-vertex"
        x={ position.x - 5 }
        y={ position.y - 5 }
        width="10"
        height="10"
        onMouseDown={ e => handleMouseDown(e) }
    />
}